import { render, staticRenderFns } from "./Like.vue?vue&type=template&id=6ca6f548&"
import script from "./Like.vue?vue&type=script&lang=js&"
export * from "./Like.vue?vue&type=script&lang=js&"
import style0 from "./Like.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ca6f548')) {
      api.createRecord('6ca6f548', component.options)
    } else {
      api.reload('6ca6f548', component.options)
    }
    module.hot.accept("./Like.vue?vue&type=template&id=6ca6f548&", function () {
      api.rerender('6ca6f548', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/summary/components/Like.vue"
export default component.exports